var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import assign from './assign';
import { register } from './factory';
import Type from './Type';
export class Generic {
    constructor(init) {
        this.type = Type.GradedText;
        const {wordGrades, isCorrect, score, copy} = init, rest = __rest(init, [
                'wordGrades',
                'isCorrect',
                'score',
                'copy'
            ]);
        this.wordGrades = wordGrades.map(wordGrade => Object.assign({}, wordGrade));
        this.isCorrect = isCorrect;
        this.score = score;
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.wordGrades.configurable = false;
        descriptors.isCorrect.configurable = false;
        descriptors.score.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class GradedText extends Generic {
}
export const klass = GradedText;
export default GradedText;
register(Type.GradedText, GradedText);    //# sourceMappingURL=GradedText.js.map
